<template>
  <div class="popup_unique_mark">
    <van-dialog
      :value="visible"
      theme='round-button'
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template #title>
        <div class="popup_header relative" :style="headerStyle">
          <div class="popup_title bold">{{ title }}</div>
          <div class="popup_close flex_center">
            <van-icon
              name="cross"
              color="#FFF"
              size="16"
              @click="handleClose"
            />
          </div>
        </div>
      </template>
      <div class="popup_content pt_8 pb_12 pl_18 pr_18">
        <div
          v-if="innerTitle"
          class="fs_18 mb_16 color_org bold text_center"
          :style="$attrs.innerTitleStyle || {}"
        >{{ innerTitle }}</div>
        <slot></slot>
        <template v-if="message.length">
          <div v-for="(msg, idx) in message" :key="msg + idx">
            <p class="text_center mb_6">{{ msg }}</p>
          </div>
        </template>
        <Progress
          v-if="progressAttrs.targetVal && showProgress"
          v-bind="progressAttrs"
        />
      </div>
      <template v-if="$slots.footer">
        <slot name="footer"></slot>
      </template>
    </van-dialog>
  </div>
</template>
<script>
import { Dialog, Icon } from 'vant';
import Progress from './Progress.vue';
export default {
  components: { 'van-dialog': Dialog.Component, 'van-icon': Icon, Progress },
  props: {
    title: {
      type: String,
      default: '系统提示'
    },
    headerStyle: {
      type: Object,
      default: () => ({})
    },
    innerTitle: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false,
    },
    headerText: {
      type: String,
      default: '系统提示'
    },
    // 内容 p 标签数组
    message: {
      type: Array,
      default: () => []
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    showProgress: {
      type: Boolean,
      default: false,
    },
    progressAttrs: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    triggerVisible (f) {
      this.$emit('update:visible', f)
    },
    handleClose () {
      this.triggerVisible(false)
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss">
.popup_unique_mark {
  background: #fff;
  .van-dialog {
    border-radius: 7px;
  }
  .van-dialog__header--isolated {
    padding: 0;
    padding-bottom: 12px;
  }
  .van-dialog__header {
    padding-top: 0;
    padding-bottom: 12px;
  }
  .popup_header {
    padding: 8px 0;
    font-size: 19px;
    font-weight: 700;
    text-align: center;
    color: #fff;
    background: linear-gradient(90deg, #ff782c 0%, #ffb503 100%);
  }
}
.van-goods-action-button--first {
  margin-right: 24px;
  border-top-right-radius: 1000px;
  border-bottom-right-radius: 1000px;
}

.van-goods-action-button--last {
  margin-right: 0 !important;
  border-top-left-radius: 1000px;
  border-bottom-left-radius: 1000px;
}

.popup_close {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
}

.popup_content {
  p {
    text-align: center;
    margin-bottom: 6px;
  }
}

</style>
